import { useParams } from "react-router-dom";
import { AiOutlineImport } from "react-icons/ai";
import EmptyStateTable from "../../../../components/emptyState/emptyStateTabel";
import ModalAddEditCompetency from "../modal/modalAddEditCompetency";
import { useState } from "react";
import {
  detailTrainingDeleteTel2Competency,
  detailTrainingDeleteTel2ParticipantEvaluation,
  detailTrainingEditTel2Competency,
  detailTrainingeDITTel2Evaluation,
  detailTrainingImportScore,
  detailTrainingNewTel2Evaluation,
} from "../../../../config/apiSPA";
import ModalInfo from "../../../../components/modal/modalInfo";
import ModalConfirm from "../../../../components/modal/modalConfirm";
import ModalEditAddEvaluationParticipant from "../modal/modalAddEditEvaluationparticipant";
import { Accordion } from "react-bootstrap";
import ModalImportTestResult from "../modal/modalImportTestResult";
const editCompetencyInitialState = {
  show: false,
  title: "No Tirle",
  data: {
    trainingId: null,
    kodeTrainingId: null,
    passingScore: 0,
    remark: "",
  },
};
const confirmModalInitialState = {
  show: false,
  title: "",
  text: "",
  theme: "",
  actionType: "",
  id: null,
};
const infoModalInitialState = {
  show: false,
  title: "",
  text: "",
  theme: "",
};
const participantEvaluationModalInitialState = {
  show: false,
  title: "",
  isEdit: false,
  data: {
    tel2CompetencyId: null, //untuk new
    tel2EvaluationId: null, //untuk edit
    trainingParticipantId: null,
    postTest: null,
    preTest: null,
    practiceTest: null,
    passingScore: null,
    result: "NOT YET",
    resultOverride: false,
    remark: "",
  },
};
const importScoreTestModalInitalStatus = {
  show: false,
  data: {
    tel2CompetencyId: null,
    soalEventId: null,
    testType: null,
    attempt: null,
  },
};
function EvaluationCompetency({ isOpen = false, onToggle = () => {}, competency = null, onUpdate = () => {} }) {
  const [editCompetencyState, setEditcompetencyState] = useState(editCompetencyInitialState);
  const [confirmModalState, setConfirmModalState] = useState(confirmModalInitialState);
  const [infoModalState, setInfoModalState] = useState(infoModalInitialState);
  const [participantEvaluationModalState, setParticipantEvaluationModalState] = useState(participantEvaluationModalInitialState);
  const [importScoreModalState, setImportScoreModalState] = useState(importScoreTestModalInitalStatus);
  const handleClickEditCompetency = () => {
    setEditcompetencyState({
      show: true,
      title: "Edit Competency",
      data: {
        trainingId: competency.id,
        kodeTrainingId: competency.title.id,
        passingScore: competency.passing_score,
        remark: competency.remark,
      },
    });
  };
  const handleSubmitEditCompetency = async ({ trainingId, kodeTrainingId, passingScore, remark }) => {
    setEditcompetencyState(editCompetencyInitialState);
    try {
      const payload = { id: trainingId, kodeTrainingId, passingScore, remark };
      const res = await detailTrainingEditTel2Competency(payload);
      onUpdate(res.data);
    } catch (error) {
      setInfoModalState({
        show: true,
        title: "Failed",
        text: `Failed to edit this competency : ${error.message}`,
        theme: "danger",
      });
    }
  };
  const handleClickDeleteCompetency = () => {
    setConfirmModalState({
      show: true,
      id: competency.id,
      title: "Warning",
      text: `Are you sure you want to delete this competency (${competency.title.title})?\nAll data associated with this competency, including evaluation scores, will also be permanently deleted.`,
      theme: "danger",
      actionType: "deleteCompetency",
    });
  };
  const handleSubmitDelete = async (e, actionType) => {
    setConfirmModalState(confirmModalInitialState);
    try {
      if (actionType === "deleteParticipantEvaluation") {
        const res = await detailTrainingDeleteTel2ParticipantEvaluation(e);
        onUpdate(res.data);
      }
      if (actionType === "deleteCompetency") {
        const res = await detailTrainingDeleteTel2Competency(e);
        onUpdate(res.data);
      }
    } catch (error) {
      setInfoModalState({
        show: true,
        title: "Failed",
        text: `Failed to delete : ${error.message}`,
        theme: "danger",
      });
    }
  };
  const handleClickAddParticipantEvaluation = (competencyId, passingScore) => {
    setParticipantEvaluationModalState({
      show: true,
      title: "Insert Participant",
      data: {
        tel2CompetencyId: competencyId,
        trainingParticipantId: null,
        postTest: null,
        preTest: null,
        practiceTest: null,
        passingScore: passingScore,
        result: "NOT YET",
        resultOverride: false,
        remark: "",
      },
    });
  };
  const handleSubmitParticipantEvaluation = async (e, isEdit) => {
    setParticipantEvaluationModalState(participantEvaluationModalInitialState);
    try {
      const res = isEdit ? await detailTrainingeDITTel2Evaluation(e) : await detailTrainingNewTel2Evaluation(e);
      onUpdate(res.data);
    } catch (error) {
      setInfoModalState({
        show: true,
        title: "Failed",
        text: `Failed to ${isEdit ? "Edit" : "Insert"} evaluation participant : ${error.message}`,
        theme: "danger",
      });
    }
  };
  const handleClickEditParticipantEvaluation = ({ id, participants, pre_test, post_test, practice_test, result, remark }, passingScore, tel2CompetencyId) => {
    setParticipantEvaluationModalState({
      show: true,
      title: "Edit Participant",
      isEdit: true,
      data: {
        tel2CompetencyId,
        tel2EvaluationId: id,
        trainingParticipantId: participants.id,
        postTest: post_test,
        preTest: pre_test,
        practiceTest: practice_test,
        passingScore: passingScore,
        result: result,
        resultOverride: false,
        remark: remark,
      },
    });
  };
  const handleClickDeleteParticipantEvaluation = ({ id, participants }) => {
    setConfirmModalState({
      show: true,
      title: "Warning !!",
      text: `Are you sure want to delete this participant ? \n${participants.manpowerData.nama}`,
      theme: "danger",
      id,
      actionType: "deleteParticipantEvaluation",
    });
  };
  const handleClickImportTestResult = (competencyId) => {
    setImportScoreModalState((prev) => ({
      show: true,
      data: { ...prev.data, tel2CompetencyId: competencyId },
    }));
  };
  const handleClickImportScore = async (e) => {
    setImportScoreModalState(importScoreTestModalInitalStatus);
    try {
      const res = await detailTrainingImportScore(e);
      onUpdate(res.data);
    } catch (error) {}
  };
  return (
    <>
      <div className="mb-3">
        <h5 className="mb-1">{competency.title.title}</h5>

        <div className="text-muted small mb-2">
          Passing Score: <strong>{competency.passing_score}</strong>
        </div>

        <div className="d-flex gap-2">
          <button type="button" onClick={() => handleClickImportTestResult(competency.id)} className="btn btn-sm btn-outline-success" title="import score from test result">
            <AiOutlineImport />
          </button>
          <button type="button" onClick={handleClickEditCompetency} className="btn btn-sm btn-outline-success">
            Edit
          </button>

          <button type="button" onClick={handleClickDeleteCompetency} className="btn btn-sm btn-outline-danger">
            Delete
          </button>
        </div>
      </div>

      <Accordion activeKey={isOpen ? "0" : null} className="mb-5">
        <Accordion.Item eventKey="0">
          <Accordion.Header onClick={onToggle}>Evaluation Result</Accordion.Header>
          <Accordion.Body>
            <div className="table-responsive">
              <table className="table table-hover text-nowrap">
                <thead className="table-light">
                  <tr>
                    <th className="border-top-0 pt-0 pb-2">No.</th>
                    <th className="border-top-0 pt-0 pb-2">Name</th>

                    <th className="border-top-0 pt-0 pb-2">Position</th>
                    <th className="border-top-0 pt-0 pb-2">Pre Test</th>
                    <th className="border-top-0 pt-0 pb-2">Post Test</th>
                    <th className="border-top-0 pt-0 pb-2">Prac. Test</th>
                    <th className="border-top-0 pt-0 pb-2">Result</th>
                    <th className="border-top-0 pt-0 pb-2">Remark</th>
                    <th className="border-top-0 pt-0 pb-2"></th>
                  </tr>
                </thead>
                <tbody>
                  {competency.evaluation.length > 0 ? (
                    competency.evaluation.map((evaluation, index) => (
                      <tr key={evaluation.id}>
                        <td className="align-middle">{index + 1}</td>
                        <td className="align-middle">{evaluation.participants.manpowerData.nama}</td>
                        <td className="align-middle">{evaluation.participants.manpowerData.jabatanFn}</td>
                        <td className="align-middle">{evaluation.pre_test}</td>
                        <td className="align-middle">{evaluation.post_test}</td>
                        <td className="align-middle">{evaluation.practice_test}</td>
                        <td className="align-middle">{evaluation.result}</td>
                        <td className="align-middle">{evaluation.remark}</td>
                        <td>
                          <div className="d-flex gap-2">
                            <a href="#/" onClick={() => handleClickEditParticipantEvaluation(evaluation, competency.passing_score, competency.id)} className="btn btn-outline-default btn-sm" title="Click to Edit">
                              <i className="fas fa-edit text-theme"></i>
                            </a>
                            <a href="#/" onClick={() => handleClickDeleteParticipantEvaluation(evaluation)} className="btn btn-outline-default btn-sm">
                              <i className="fas fa-trash-alt text-danger"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <EmptyStateTable colSpan={8} />
                  )}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <button onClick={() => handleClickAddParticipantEvaluation(competency.id, competency.passing_score)} type="button" className="btn btn-outline-success btn-sm">
                <i className="fas fa-plus me-1"></i>
                Add
              </button>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <ModalImportTestResult show={importScoreModalState.show} data={importScoreModalState.data} onHide={() => setImportScoreModalState(importScoreTestModalInitalStatus)} submitClick={handleClickImportScore} />
      <ModalAddEditCompetency
        show={editCompetencyState.show}
        onHide={() => setEditcompetencyState(editCompetencyInitialState)}
        title={editCompetencyState.title}
        data={editCompetencyState.data}
        submitClick={(e) => handleSubmitEditCompetency(e)}
      />
      <ModalInfo show={infoModalState.show} onHide={() => setInfoModalState(infoModalInitialState)} title={infoModalState.title} text={infoModalState.text} clicked={() => setInfoModalState(infoModalInitialState)} />
      <ModalConfirm
        show={confirmModalState.show}
        onHide={() => setConfirmModalState(confirmModalInitialState)}
        title={confirmModalState.title}
        text={confirmModalState.text}
        id={confirmModalState.id}
        clicked={(e) => handleSubmitDelete(e, confirmModalState.actionType)}
        theme={confirmModalState.theme}
      />
      <ModalEditAddEvaluationParticipant
        submitClick={(e, isEdit) => handleSubmitParticipantEvaluation(e, isEdit)}
        show={participantEvaluationModalState.show}
        onHide={() => setParticipantEvaluationModalState((a) => ({ ...a, show: false }))}
        data={participantEvaluationModalState.data}
        isEdit={participantEvaluationModalState.isEdit}
        title={participantEvaluationModalState.title}
      />
    </>
  );
}

export default EvaluationCompetency;
